package pwgs.ui.scenes.diagnosticserrorgroupsscene


class DiagnosticsErrorGroupsControllerFe(props: DiagnosticsErrorGroupsSceneProps, scene: MDiagnosticsErrorGroupsScene) : ADiagnosticsErrorGroupsControllerFe(props, scene) {

    override fun createInitialModel() : DiagnosticsErrorGroupsSceneModel {
        return DiagnosticsErrorGroupsSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }


}

